import { createCallIssueDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createCallIssueCallable = getCallable(createCallIssueDefinition);
